<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Transferencias pendientes</span>
          <h2 class="workspace-title">Validacion de comprobantes</h2>
          <p class="workspace-copy">Revisa capturas, define el estado final y resuelve la cola de validacion.</p>
        </div>
      </div>

      <div class="workspace-metrics">
        <article class="workspace-metric">
          <small>Pagos pendientes</small>
          <strong>{{ filteredEvents.length }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Monto en revision</small>
          <strong>${{ pendingTotal }}</strong>
        </article>
      </div>

      <div class="workspace-toolbar">
        <label class="workspace-search">
          <i class="fas fa-search"></i>
          <input v-model="search" type="text" placeholder="Buscar por cliente, comprobante o evento" />
        </label>
      </div>

      <div v-if="!filteredEvents.length" class="workspace-empty">No hay transferencias pendientes.</div>
      <div v-else class="workspace-table-shell">
        <table class="workspace-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>Comprobante</th>
              <th>Evento</th>
              <th>Captura</th>
              <th>Monto</th>
              <th>Analisis</th>
              <th>Estado</th>
              <th>Accion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in filteredEvents" :key="payment.id">
              <td>{{ payment.id }}</td>
              <td>{{ formatDate(payment.date) }}</td>
              <td>{{ payment.customer }}</td>
              <td>{{ payment.url_number }}</td>
              <td>{{ payment.event }}</td>
              <td><a class="workspace-inline-link" :href="payment.file" target="_blank">Ver imagen</a></td>
              <td>${{ formatMoney(payment.amount) }}</td>
              <td>
                <span :class="['workspace-status-pill', payment.automatic_validation ? 'is-active' : 'is-warning']">
                  {{ payment.automatic_validation ? 'Validacion automatica' : 'Revisar' }}
                </span>
              </td>
              <td>
                <select class="workspace-input workspace-select" :key="payment.id" @change="setPaymentStatus(payment, $event)">
                  <option value="0" disabled selected>Estado</option>
                  <option value="1">Aprobado</option>
                  <option value="2">Pago falso</option>
                  <option value="3">Pago duplicado</option>
                  <option value="6">Transferido</option>
                </select>
              </td>
              <td>
                <button class="workspace-button workspace-button--primary workspace-button--small" type="button" @click="changeStatusByPayment(payment)">
                  <i class="fas fa-check"></i>
                  <span>Confirmar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="workspace-actions workspace-actions--end">
        <spring-spinner v-if="loading" v-show="next" :size="48" color="#8cf3e8" />
        <button v-show="next && !loading" class="workspace-button" type="button" @click="getEvents">Cargar mas</button>
      </div>
    </article>
  </section>
</template>

<script>
import { apiService } from "../../common/api.services.js";
import { SpringSpinner } from 'epic-spinners';

export default {
  name: "AssistanceList",
  data() {
    return {
      events: [],
      next: null,
      loadingTable: true,
      search: "",
      loading: false,
      promoter_table:[],
      is_staff:localStorage.getItem('is_staff')
    };
  },
  components: {
    SpringSpinner,
  },

  props: {
    event: {
      required: true,
    },
  },

  computed: {
    filteredEvents() {
      const term = this.search.trim().toLowerCase()
      if (!term) {
        return this.events
      }

      return this.events.filter((payment) => {
        const haystack = `${payment.customer || ''} ${payment.url_number || ''} ${payment.event || ''}`.toLowerCase()
        return haystack.includes(term)
      })
    },

    pendingTotal() {
      const total = this.filteredEvents.reduce((sum, payment) => sum + (Number.parseFloat(payment.amount) || 0), 0)
      return total.toFixed(2)
    },
  },

  created() {
    this.getEvents();
  },

  methods: {


    
    setPaymentStatus(payment, event){
      const index = this.events.findIndex((item) => item.id === payment.id)
      if (index === -1) {
        return
      }

      if (event.target.value==1){
        this.events[index].status=1
      }else if (event.target.value==2){
        this.events[index].status=2
      }else if (event.target.value==6){
        this.events[index].status=6
      }else{
        this.events[index].status=3
      }

    },

    formatMoney(value) {
      const parsed = Number.parseFloat(value)
      return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2)
    },


    changeStatus(index){
    this.success = false

    let id = this.events[index].id


    let endpoint =  `/api/payment/${id}/change?type=${this.events[index].status}`
    apiService(endpoint, "PUT")
              .then(data => {
                  if (data.id){
                    this.events.splice(index, 1)
                  }else{
                      //Especificar error
                      this.error=data.err
                  }

    
              })



    },

    changeStatusByPayment(payment) {
      const index = this.events.findIndex((item) => item.id === payment.id)
      if (index === -1) {
        return
      }

      if (!this.events[index].status) {
        return
      }

      this.changeStatus(index)
    },





    formatDate(dateString){
              const date = new Date(dateString);
                // Then specify how you want your dates to be formatted

                console.log(date)
            return new Intl.DateTimeFormat('default', {dateStyle: 'short'}).format(date);
    },



    populateBar() {
      this.generatedBar = {
        labels: ["Tarjeta", "Transferencia", "Efectivo"],
        datasets: [
          {
            label: "$",
            backgroundColor: "blue",
            data: [this.card, this.bank, this.cash],
          },
        ],
      };
    },

    populateData() {
      let labelArr = [];
      let backgroundColorArr = [];
      let dataArr = [];

      for (let index = 0; index < this.eventTickets.length; index++) {
        console.log("paso");

        let lname =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        labelArr.push(lname);

        let maxVal = 0xffffff; // 16777215
        let randomNumber = Math.random() * maxVal;
        randomNumber = Math.floor(randomNumber);
        randomNumber = randomNumber.toString(16);
        let randColor = randomNumber.padStart(6, 0);
        let color = `#${randColor.toUpperCase()}`;
        backgroundColorArr.push(color);

        let value =
          this.eventTickets[index].initial_quantity -
          this.eventTickets[index].remaining_tickets;
        dataArr.push(value);

        let obj = Object();
        obj.section =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        obj.tickets = value;
        obj.remaining = this.eventTickets[index].remaining_tickets;
        this.total_tickets.push(obj);
      }
      this.loadingTable = false;
      console.log(labelArr);
      console.log(dataArr);
      console.log(backgroundColorArr);

      this.generatedData = {
        labels: labelArr,
        datasets: [
          {
            label: "Tickets x Sección",
            backgroundColor: backgroundColorArr,
            data: dataArr,
          },
        ],
      };
    },

    openEvent(_id) {
      this.$router.push({ name: "EventHostView", params: { slug: _id } });
    },

    searchEvents() {
      this.events = [];
      this.getEvents();
      this.next = null;
    },

    populateDataS(){

      

        let money_count=0
        let sale_count=0


        let array= this.events
        let code_n=array[0].product_code


      





        for (let index = 0; index < array.length; index++) {
          if (array[index].product_code==code_n){
          money_count=parseFloat(money_count)+parseFloat(array[index].amount)
          sale_count++;
         
        }else{
          let payment_obj = Object()
          payment_obj.money=money_count
          payment_obj.code=array[index].product_code
          payment_obj.count=sale_count


          this.promoter_table.push(payment_obj)
          money_count=0
          sale_count=0
          code_n=array[index].product_code
          console.log(code_n)

        }
        }
    },

    getEvents() {
      // make a GET Request to the questions list endpoint and populate the questions array

      //tipo 1 para generico y tipo 2 para mis cursos y usar el mismo componente
      let endpoint = "/api/payments/?status=pending";
       

      if (this.next) {
        endpoint = this.next;
        this.loading=true
      }
      this.loadingQuestions = true;
      apiService(endpoint).then((data) => {
        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.events = this.events.concat(items);
        this.showLoading = false;
        this.loading=false
        if (data && data.next) {
          //si no es null
          this.next = data.next;
        } else {
          //Si no es null
          this.next = null;
        }
       // this.populateDataS()
      });

      
    
    
    },

  },
};
</script>

<style scoped>
.workspace-table-shell {
  overflow: auto;
}

.workspace-table {
  width: 100%;
  border-collapse: collapse;
}

.workspace-table th,
.workspace-table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(223, 214, 255, 0.08);
  text-align: left;
  color: var(--text-soft);
}

.workspace-table th {
  color: var(--text-main);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.workspace-inline-link {
  color: #cbffe8;
}
</style>
